import { render, staticRenderFns } from "./DetailHasilUjianKecermatanSiswa.vue?vue&type=template&id=8c80e426"
import script from "./DetailHasilUjianKecermatanSiswa.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianKecermatanSiswa.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianKecermatanSiswa.vue?vue&type=style&index=0&id=8c80e426&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports